import { useRef, useEffect } from "react";

export function useHorizontalScroll() {
  const elRef = useRef();
  useEffect(() => {
    const el = elRef.current;
    if (el) {
      const onWheel = e => {
        if (e.deltaY === 0) return;
        e.preventDefault();
        el.scrollBy({
          left:  e.deltaY < 0 ? -50 : 50,
        });
      };
      el.addEventListener("wheel", onWheel, {passive: false});
      return () => el.removeEventListener("wheel", onWheel);
    }
  }, []);
  return elRef;
}